import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth";
import { useCredentialsClient } from "@/features/credentials/hooks/use-credentials-client";
import { credentialsQueryKeys } from "@/features/credentials/queries/credentials-query-keys";

export function useDeleteCredentialMutation() {
  const queryClient = useQueryClient();
  const { productToken } = useAuth();
  const credentialsClient = useCredentialsClient();

  return useMutation({
    mutationFn: ({
      sport,
      organizationId,
      credentialId,
    }: {
      sport: string;
      organizationId: string;
      credentialId: string;
    }) =>
      credentialsClient.deleteCredential({
        productToken: productToken as string,
        sport,
        organizationId,
        credentialId,
      }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: credentialsQueryKeys.list({
          sport: variables.sport,
          organizationId: variables.organizationId,
        }),
      });
    },
  });
}
